// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_se-0";